import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { OAuthModuleConfig as LibOAuthModuleConfig, provideOAuthClient } from 'angular-oauth2-oidc';
import { authFeatureKey } from './auth-state';
import { ClientIdHttpInterceptor } from './client-id-http-interceptor';
import { ImpersonateClientEffects, LogoutEffects } from './effects';
import { ReloadUserInfoEffect } from './effects/reload-user-info-effect';
import { SignInClientEffects } from './effects/sign-in-client-effect';
import { OAuthModuleConfig } from './oauth-module.config';
import * as fromAuth from './reducers/auth.reducer';
import { TryLoginInitializerProvider } from './try-login-initializer.provider';

export function provideWfeProxyOidc(config?: OAuthModuleConfig | undefined) {
  return makeEnvironmentProviders([
    provideState(authFeatureKey, fromAuth.reducer),
    provideEffects([ImpersonateClientEffects, ReloadUserInfoEffect, LogoutEffects, SignInClientEffects]),
    provideOAuthClient(config),
    TryLoginInitializerProvider,
    { provide: HTTP_INTERCEPTORS, useClass: ClientIdHttpInterceptor, multi: true },
    { provide: OAuthModuleConfig, useValue: config },
    { provide: LibOAuthModuleConfig, useExisting: OAuthModuleConfig }
  ]);
}
